import { envToBoolean, envToReasonablySizedString } from './utils';

export const INFRASTRUCTURE_API_BASE_URL = envToReasonablySizedString(
    process.env.NEXT_PUBLIC_INFRASTRUCTURE_API_BASE_URL
);

export const INFRASTRUCTURE_STATIC_TILE_URL = envToReasonablySizedString(
    process.env.NEXT_PUBLIC_INFRASTRUCTURE_STATIC_TILE_URL
);
export const SHOW_CAPTURES_MISSING_TOTAL = envToBoolean(process.env.NEXT_PUBLIC_SHOW_CAPTURES_MISSING_TOTAL);
export const INFRASTRUCTURE_DYNAMIC_TILE_URL = envToReasonablySizedString(
    process.env.NEXT_PUBLIC_INFRASTRUCTURE_DYNAMIC_TILE_URL
);
export const TITILER_URL = envToReasonablySizedString(process.env.NEXT_PUBLIC_TITILER_URL);

export const EMISSION_DB_URL = envToReasonablySizedString(process.env.NEXT_PUBLIC_EMISSION_DB_URL);

export const POINT_SOURCES_URL = envToReasonablySizedString(process.env.NEXT_PUBLIC_POINT_SOURCES_URL);

export const TARGETS_URL = envToReasonablySizedString(process.env.NEXT_PUBLIC_TARGETS_URL);

export const SHOW_L3_OPTION = envToBoolean(process.env.NEXT_PUBLIC_SHOW_L3_OPTION);

export const OVERZOOM_ON_USER_INTERACTION = envToBoolean(process.env.NEXT_PUBLIC_OVERZOOM_ON_INTERACTION);

export const SHOW_ZOOM_FOR_DETAILS = envToBoolean(process.env.NEXT_PUBLIC_SHOW_ZOOM_FOR_DETAILS);
